import { ReactNode } from 'react';

interface StepHeaderProps {
  title: string;
  subtitle: string;
  rightSlot?: ReactNode;
}

const StepHeader = ({ title, subtitle, rightSlot }: StepHeaderProps) => (
  <div className="flex items-center justify-between gap-4">
    <div className="flex flex-col gap-1">
      <h2 className="text-lg font-bold text-gray-900">{title}</h2>
      <p className="text-xs text-gray-500">{subtitle}</p>
    </div>
    {rightSlot}
  </div>
);

export default StepHeader;
